(function(window, $, undefined) {
    window.JVZoo = window.JVZoo || {};
    window.JVZoo.Controls = window.JVZoo.Controls || {};

    /**
     * JQuery plugin function to parse out the "z" part of a name like "x[0][y][z]"
     * @type {*|Function}
     */
    $.fn.getUnqualifiedFieldName = $.fn.getUnqualifiedFieldName || function(){
        var name = this.attr('name');
        var nameParts = name.match(/([^\[\]]+)/g);
        if (nameParts && nameParts.length > 0) {
            name = nameParts.pop();
        }
        return name;
    };

    /**
     * Given an element, this function looks at all children of that element, and then looks at all parents of those
     * children that have either a 'name' or 'data-form-field-index' attribute. It then walks that collection to create
     * a "fully qualified form field name" that is composed of all names, and all indexes, above each input plus the
     * input's own name
     * @param element
     * @constructor
     */
    window.JVZoo.Controls.SetFullyQualifiedFieldNames = function(element) {
        var $element = window.JVZoo.Common.AsjQueryObject(element);

        var $inputs = $element.find('input[name], select[name]');
        if (!$inputs || $inputs.length < 1) {
            return;
        }
        /*
         * foreach control within this element, find all parent elements with a name or data-form-field-index attribute
         * then step through each one building the "qualified field name"
         */
        $inputs.each(function (index, input) {
            var $input = window.JVZoo.Common.AsjQueryObject(input);
            var newFieldName = '['+$input.getUnqualifiedFieldName()+']';
            //check for a containing element that specifies a field index for it's contained inputs
            var $closestIndex = $input.parent().closest('[data-form-field-index]');
            if ($closestIndex && $closestIndex.length > 0) {
                newFieldName = '['+$closestIndex.attr('data-form-field-index')+']'+newFieldName;
            }
            //check for a containing element that specifies a prefix for it's contained inputs
            var $parentWithPrefix = $input.parent().closest('[data-form-field-prefix]');
            if ($parentWithPrefix && $parentWithPrefix.length > 0) {
                newFieldName = $parentWithPrefix.attr('data-form-field-prefix')+newFieldName;
            }
            $input.attr('name', newFieldName);
            $input.attr('data-form-field-prefix', $input.attr('name'));
        });

    };

})(window, jQuery);

(function(window, $, undefined){
    window.JVZoo = window.JVZoo || {};
    window.JVZoo.Controls = window.JVZoo.Controls || {};

    window.JVZoo.Controls.FirstTagRegEx = function(tagType) {return new RegExp('(^[^<]*<\\W*\\b)'+tagType+'(\\b)', 'i');};
    window.JVZoo.Controls.LastTagRegEx = function(tagType) { new RegExp('(<\\/?\\W*\\b)'+tagType+'(\\b[^>]*>$)', 'i');};

    function Event() {
        var _this = this;
        _this.delegates = [];
    }

    Event.prototype.subscribe = function (source, delegate, subscriberSuppliedArgs) {
        var _this = this;
        _this.delegates.push({source:source, delegate:delegate, subscriberSuppliedArgs:subscriberSuppliedArgs});
    };

    Event.prototype.raise = function (source, targetElement) {
        var _this = this;
        var args = {
            eventSource:source,
            targetElement: targetElement,
            cancel:false
        };
        _this.delegates.forEach(function(subscriber, index) {
            if (args.cancel) {
                return;
            }
            args.subscriberSuppliedArgs = subscriber.subscriberSuppliedArgs;
            if (subscriber.source) {
                subscriber.delegate.bind(subscriber.source);
                subscriber.delegate(args);
            } else {
                subscriber.delegate(args);
            }
          }
        )
    };

    window.JVZoo.Controls.NewControlEvent = new Event();

    window.JVZoo.Controls.FileInputReset = new Event();

    window.JVZoo.Controls.PauseFormSubmission = new Event();

    window.JVZoo.Controls.AllowFormSubmission = new Event();

})(window, jQuery);
//custom control configuration errors
(function(window, $, undefined){

    window.JVZoo = window.JVZoo || {};
    window.JVZoo.Controls = window.JVZoo.Controls || {};

    window.JVZoo.Controls.ShowErrorsForTag = function(tag, errors) {
        var $tag = window.JVZoo.Common.AsjQueryObject(tag);

        var $errorsDiv = $('<div>')
            .addClass('flex-column')
            .addClass('jvz-ctl-errors')
            .append('<h4>'+$tag.prop("tagName")+' errors:</h4>');

        errors.forEach(function(item){
            $errorsDiv.append(
                $('<div class="jvz-ctl-error">').text(item)
            );
        });

        $errorsDiv.insertAfter($tag);
        console.log("Boo!");
    }

})(window, jQuery);